import mainApiClient from '../clients/mainApiClient';
import { API_ENDPOINTS } from '../endpoints';
import { resolveClientTimeZone } from '../../utils/timeZone';

function normalizeFilters(filters) {
  if (!filters) {
    return undefined;
  }

  return typeof filters === 'string' ? filters : JSON.stringify(filters);
}

function normalizeIds(ids) {
  const values = Array.isArray(ids) ? ids : String(ids ?? '').split(',');

  return Array.from(new Set(values
    .map((value) => String(value ?? '').trim())
    .filter(Boolean)));
}

function normalizeDateParam(value) {
  const normalized = String(value ?? '').trim();
  const dateMatch = normalized.match(/^(\d{4}-\d{2}-\d{2})/);

  return dateMatch?.[1] || undefined;
}

export const operationsApi = {
  getFilters({
    id,
    _id,
    ids,
    cardIds,
    minDate,
    min_date,
    maxDate,
    max_date,
    timezone,
  } = {}) {
    const selectedCardIds = normalizeIds(cardIds);
    const explicitIds = normalizeIds(ids);
    const legacyIds = normalizeIds(id ?? _id);
    const requestedCardIds = explicitIds.length > 0
      ? explicitIds
      : selectedCardIds.length > 0
        ? selectedCardIds
        : legacyIds;

    return mainApiClient.get(API_ENDPOINTS.operations.getFilters, {
      auth: true,
      params: {
        ids: requestedCardIds.length > 0 ? requestedCardIds.join(',') : undefined,
        min_date: normalizeDateParam(minDate ?? min_date),
        max_date: normalizeDateParam(maxDate ?? max_date),
        timezone: resolveClientTimeZone(timezone),
      },
    });
  },

  getAll({ limit = 25, lastId, last_id, filters, timezone } = {}) {
    return mainApiClient.get(API_ENDPOINTS.operations.getAll, {
      auth: true,
      params: {
        limit,
        last_id: lastId ?? last_id,
        filters: normalizeFilters(filters),
        timezone: resolveClientTimeZone(timezone),
      },
    });
  },

  getById({ id, _id } = {}) {
    return mainApiClient.get(API_ENDPOINTS.operations.getById, {
      auth: true,
      params: {
        _id: id ?? _id,
      },
    });
  },

  getCsvFile({
    limit = 25,
    lastId,
    last_id,
    filters,
    fileType = 'csv',
    file_type,
  } = {}) {
    return mainApiClient.post(
      API_ENDPOINTS.operations.getCsvFile,
      {
        limit,
        last_id: lastId ?? last_id,
        filters: filters || null,
        file_type: file_type ?? fileType,
      },
      {
        auth: true,
      }
    );
  },
};
